import language from "./mixins/language";
export default {
  name: "cookie-policy",
  mixins: [language],
  methods: {
    afterCreated: function afterCreated() {
      document.title = this.$t('cookie_policy.title'); // 标题国际化
    }
  }
};